import { XMarkIcon } from "@heroicons/react/24/solid";
import { useRef, useState } from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

import { ReportSectionFieldTypeEnums } from "@api/graphql/types-and-hooks";
import { ContentBlockCard } from "@components/SectionWidget/ContentBlockCard";
import { SupportedContentType, getFieldTypeByContent } from "@components/SectionWidget/SectionWidget";

interface AddContentMenuProps {
  sectionType: "regular" | "recommendation";
  supportedContentTypes: SupportedContentType[];
  onAddContent: (fieldType: ReportSectionFieldTypeEnums, rankOrder: number) => Promise<unknown>;
  newRankOrder: number;
}

export const AddContentMenu: React.FC<AddContentMenuProps> = ({
  sectionType = "regular",
  supportedContentTypes,
  onAddContent,
  newRankOrder,
}) => {
  const [showContentMenu, setShowContentMenu] = useState(false);

  const divRef = useRef<HTMLDivElement>(null);

  const handleAddContent = async (type: SupportedContentType) => {
    const fieldType = getFieldTypeByContent(type);
    if (fieldType) {
      await onAddContent(fieldType, newRankOrder);
    }

    setShowContentMenu(false);
  };

  return (
    <div className="relative">
      <div className="flex justify-center">
        {showContentMenu ? (
          <div className="flex justify-center rounded-md w-full -mb-6 mr-6 bg-background-secondary">
            <div className="flex flex-row my-4 grow justify-center" ref={divRef}>
              {supportedContentTypes.map((_typeName, index) => (
                <ContentBlockCard
                  key={`${index}_${_typeName}`}
                  typeName={_typeName}
                  onClick={() => handleAddContent(_typeName)}
                />
              ))}
            </div>
            <XMarkIcon
              onClick={() => {
                setShowContentMenu(false);
              }}
              className="h-6 w-6 cursor-pointer bg-transparent m-2 text-text-primary"
            />
          </div>
        ) : (
          <>
            <div className="flex justify-center -mb-6 w-full h-4">
              <div
                data-testid="add-content-hover-area"
                className="flex items-center size-full group pr-6"
                onClick={() => setShowContentMenu(true)}
              >
                <div className={`transition-all my-3 border border-rio-600 flex-1 group-hover:block hidden`} />
                <div className={`p-2 text-center border rounded-md group-hover:block hidden bg-white`}>
                  <Small
                    data-testid="add-content-button"
                    displayType="normal"
                    className={`cursor-pointer  group-hover:text-text-primary transition-all `}
                  >
                    Add {sectionType === "regular" ? "Content" : "Recommendation"}
                  </Small>
                </div>
                <div className={`transition-all my-3 border border-rio-600 flex-1 group-hover:block hidden`}></div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
